import { scrollToId } from "../lib/scroll";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B241A" />
    <path d="M17 45 L30 30 L36 36 L47 22" stroke="#D4AF37" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M35 22 h12 v12" stroke="#D4AF37" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Logo({ onClick }) {
  return (
    <a
      href="#hero"
      onClick={(e) => { e.preventDefault(); if (onClick) onClick(); scrollToId("hero"); }}
      data-testid="logo-booster"
      className="flex items-center gap-2.5"
      aria-label="BOOSTER — kembali ke atas"
    >
      <LogoMark />
      <span className="text-lg font-black tracking-[0.22em] text-cream">BOOSTER</span>
    </a>
  );
}
